import { render, staticRenderFns } from "./MenuWallet.vue?vue&type=template&id=79b789a5&"
import script from "./MenuWallet.vue?vue&type=script&lang=js&"
export * from "./MenuWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports